import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bulkUploadSearchfilter'
})
export class BulkUploadSearchfilterPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    items = items.filter(item => item.uploadForName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.fileName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.statusName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.totalRecordString.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.failedRecordString.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.successRecordString.toLowerCase().indexOf(filter.toLowerCase()) !== -1 );
    return items;
  }

}
